export class Vaccination {
  created_at: string;
  updated_at: string;
  name: string;
  date: string;
  herpes: boolean;
  influenza: boolean;
  immunization: string;
  number: string;
  other: boolean;
  id: number;
  vaccination_countries: (string | number) [] = [];
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/vaccination.ts